import {
  Component,
  EventEmitter,
  Input, OnInit,
  Output
} from '@angular/core';
import { rotateIcon } from '../../animations/rotateIcon.animation';
import { ModifierPipe } from '../../pipes/modifier.pipe';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Product } from 'app/models/organization.model';
import { RadioSelectOption } from 'app/shared/components/radio-select/radio-select.component';
import { Helpers } from 'app/helpers/helpers';
import { ICartGroup, ICartProduct } from 'app/models/cart.model';
import { TranslateService } from '@ngx-translate/core';

@UntilDestroy()
@Component({
  selector: 'app-product-modifier-group',
  templateUrl: './product-modifier-group.component.html',
  styleUrls: ['./product-modifier-group.component.scss'],
  providers: [ModifierPipe],
  animations: [rotateIcon],
})
export class ProductModifierGroupComponent implements OnInit {
  @Input() productGroup: ICartGroup;
  @Output() productGroupChange = new EventEmitter<ICartGroup>();
  @Input() product: Product;
  @Input() item: ICartProduct;
  @Output() itemChange = new EventEmitter<ICartProduct>()
  @Output() notifyChange: EventEmitter<any> = new EventEmitter();

  @Input() size: string | null = null;
  // Если false, означает что в группе выбрано не достаточное кол-во модификаторов.
  groupIsMinFull: boolean;
  // Если true, означает что в группе выбрано максимальное кол-во модификаторов.
  groupIsMaxFull: boolean;
  panelExpanded = true;

  showGroupAsRadioSelect: boolean = false;

  // поле используется в случае, если в группе можно выбирать только 1 модификатор, и группа будет выглядеть как radio-select
  radioModifiers: RadioSelectOption[] = [];

  constructor(private translateService: TranslateService) {
  }

  ngOnInit(): void {
    // Определяем в каком виде будет выглядеть группа.
    // Также за вид частично отвечает логика в разметке со своими #ngIf - возможно надо ее исправить на более понятную.
    if (this.productGroup.minAmount === 1 && this.productGroup.maxAmount === 1){
      this.showGroupAsRadioSelect = true;
      this.radioModifiers = this.buildModifierRadioSelectOptions();
    }

    this.groupIsMinFull = this.productGroup.minAmount == 0;
    this.groupIsMaxFull = false;
  }

  //--------------------------------------------------------------------------Операции по изменению кол-ва модификаторов-----------------
  // После изменения кол-ва выбранного модификатора в корзине, надо уведомить этот компонент и пересчитать что еще осталось выбрать,
  // а также уведомить родительский компонент, чтобы тот тоже посчитал, какие группы не доконца пополнены.
  // Подразумевается, что все дочерние компоненты при своих изменениях будут уведомлять этот компонент.
  notifyChangeByModifier() {
    const selectedQuantity = this.productGroup.modifiers.reduce((sum, nextMod) => (sum + nextMod.selectedQuantity), 0);
    this.productGroup.selectedQuantity = selectedQuantity;
    this.groupIsMinFull = selectedQuantity >= this.productGroup.minAmount;
    this.groupIsMaxFull = selectedQuantity >= this.productGroup.maxAmount;
    this.notifyChange.emit();
  }

  selectRadioModify(modifierId: string){
    this.productGroup.modifiers.forEach(m => {
      m.selectedQuantity = m.id == modifierId ? 1 : 0;
    });
    this.notifyChangeByModifier();
  }
  //--------------------------------------------------------------------------

  // Создание полей radio-select-options для обязательного единственного модификатора в группе
  buildModifierRadioSelectOptions(): RadioSelectOption[] {
    const result = this.productGroup.modifiers.map(modifier => {
      modifier.calculatedPrice = Helpers.calculatePriceModifier(modifier, this.item.selectedSizeId);

      return {
        value: modifier.id,
        name: modifier.name,
        price: modifier.calculatedPrice,
      } as RadioSelectOption;
    });

    return result;
  }

  getGroupName(group: ICartGroup){
    let resultName = group.name;

    if (group.minAmount == 1 && group.maxAmount == 1){
      return resultName;
    }

    if (group.minAmount){
      resultName = `${resultName}, ${this.translateService.instant('MIN')}:${group.minAmount}`;
    }

    if (group.maxAmount){
      resultName = `${resultName},  ${this.translateService.instant('MAX')}:${group.maxAmount}`;
    }

    return resultName;
  }
}
